import { css, type Theme } from '@emotion/react';

export const container = css`
 display: flex;
 flex-direction: column;
 gap: 10px;
`;

export const item = css`
 display: flex;
 flex-direction: column;
 gap: 10px;
`;

export const data = (theme: Theme) => css`
  display: flex;
  gap: 8px;
  align-items: center;

  color: ${theme.colors.gray[600]};
`;

export const select = css`
  width: 160px;
`;
